import React, { useState, useRef, useEffect } from "react";
import Card from "../../Components/VoteCard/Card";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { Navigate } from "react-router-dom";
import MyBackDrop from "../../Components/Modals/backDrop";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import {
  getExecutiveCandidates,
  getUserVotes,
} from "../../Sevices/api-requests";
import { useParams } from "react-router-dom";
import { Typography, Link } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
  })
);
const ExecutiveVotes = ({ user }) => {
  let { level, userId } = useParams();
  const [excos, setExcos] = useState([]);
  const [voted, setVoted] = useState(false);

  useEffect(() => {
    getCandidates();
  }, []);

  const classes = useStyles();

  const getCandidates = () => {
    getExecutiveCandidates(level).then((result) => {
      setExcos(result.data.data);
    });

    getUserVotes(userId).then((result) => {
      const newResult = result.data.data.some((vote) => {
        return vote.position == level;
      });

      if (newResult) {
        setVoted(true);
      }
    });
  };

  const disabled = () => {
    if (excos.length > 1) {
      return true;
    } else {
      return false;
    }
  };
  //console.log(position );
  //  const myMap = position? Object.keys(position).map(key=>  {
  //   return {name:key, votes:Object.values([position[key]])}
  // }):[]
  //const {currentUser} = user
  //  const {level} = currentUser
  //console.log(myMap)
  return !user ? (
    <Navigate replace to="/login" />
  ) : (
    <div
      style={{ marginBottom: "10%", justifyContent: "center", marginTop: "5%" }}
    >
      {!voted ? (
        <div>
          <Typography
            style={{ textAlign: "center", fontSize: "20px", marginTop: "2%" }}
          >
            <Link
              href="/executives"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              {" "}
              <ArrowBackIcon />
              <b>Back to executives</b>
            </Link>
          </Typography>
          <div>
            <Grid
              container
              alignContent="center"
              style={{ marginLeft: "%", marginTop: "2%", marginBottom: "10%" }}
              justifyContent="center"
              spacing={2}
            >
              {excos.map((exco, i) => {
                return (
                  <Card
                    key={i}
                    name={exco.name}
                    userId={user._id}
                    reload={getCandidates}
                    level={user.level}
                    category="executive"
                    disabled={disabled}
                    image={exco.image}
                    position={exco.position}
                  />
                );
              })}
            </Grid>
            <div className="centre"></div>
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            marginTop: "40vh",
          }}
        >
          <Typography>{user.firstName}, Thank you for voting!</Typography>
          <Typography
            style={{ textAlign: "center", fontSize: "20px", marginTop: "2%" }}
          >
            <Link
              href="/executives"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              {" "}
              <ArrowBackIcon />
              <b>Vote other executives</b>
            </Link>
          </Typography>
          <Typography
            style={{ textAlign: "center", fontSize: "20px", marginTop: "2%" }}
          >
            {user.level == "700" ? null : (
              <Link
                disabled={user.level == "700"}
                href={`/senate/${user.level}/${user._id}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexWrap: "wrap",
                }}
              >
                {" "}
                <ArrowBackIcon />
                <b>Go to senate</b>
              </Link>
            )}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default ExecutiveVotes;
